import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useAppDispatch } from 'store';

import { startTimer } from 'modules/blok-test';
import { $apiV2, errorHandler, globalConst } from 'modules/global';

import { setTestData } from '../store';

export const useCreateTest = () => {
  const dispatch = useAppDispatch();
  const { push } = useRouter();

  return useMutation({
    mutationFn: async (requestData: { language_id?: number; year_id?: number; subject_id?: number, test_id?: number }) => {
      const { data } = await $apiV2.post('/nat-certificate/order', requestData);

      return data;
    },
    onSuccess: data => {
      dispatch(setTestData(data?.data));
      dispatch(startTimer());
      push(globalConst.pageNames.NATIONAL_CERTIFICATE_TEST);
    },
    onError: errorHandler()
  });
};
